/*
 * @Author: wzc
 * @Date: 2024-06-29 10:42:36
 * @LastEditors: wzc
 * 超赛平台 base mixins 中国网球公开赛
 * @LastEditTime: 2024-06-29 19:11:02
 */

import bigSports_mixin from '@mixins/tennis/chinaOpen/bigSportsList_mixin.js'
export default {
  mixins: [bigSports_mixin],
  data() {
    return {
      containerFullClassName: 'containerFull_tennis_chinaOpen',
      defaultPath: ['tennis', 'chinaOpen', 'schedule'],
      axiosBaseUrl: '/tennis',
      sportCompetitionType: 'tennis_chinaOpen', //暂时不加具体中网|汤尤杯这种赛事区别，如果需要后面补字段即可【tennis_chinaOpen,badminton_thomasAndUber】
      themeSeasonArr: [
        {
          sidArr: ['6012026', '6012025', '6012024', '6012023'],
          themeIndex: 0,
        },
      ],
    }
  },
}
